import { Translations } from './types';

export const pl: Translations = {
  // App & Branding
  app_title: 'Slimelings: Bit-It!',
  app_subtitle: 'Szybka Karcianka Blefu i Strategii',
  app_slogan: 'Dwa razy więcej kłopotów... o połowę mniej wyrzutów sumienia.',
  app_description: 'Dynamiczne starcia karciane dla 1 do 4 graczy. Blefuj, podbijaj stawkę z Bit-It! i zdobądź 16 punktów, aby wygrać.',

  // Locales
  lang_pt: 'Português (BR)',
  lang_en: 'English (US)',
  lang_pl: 'Polski (PL)',

  // Game Modes
  mode_duel: 'Pojedynek 1v1',
  mode_duel_desc: 'Bezpośrednie starcie jeden na jednego.',
  mode_teams: 'Drużyny 2v2',
  mode_teams_desc: 'Ty i Twój partner przeciwko wrogiej parze.',
  mode_ffa: 'Każdy na Każdego (4P FFA)',
  mode_ffa_desc: 'Taktyczny chaos: 4 graczy rywalizuje indywidualnie o każdą lewę.',

  // Bot Personalities & Levels
  bot_level_1: 'Poziom 1 (Łatwy)',
  bot_level_2: 'Poziom 2 (Średni)',
  bot_level_3: 'Poziom 3 (Trudny)',
  bot_aggressive: 'Poziom 3 (Trudny)',
  bot_cautious: 'Poziom 1 (Łatwy)',
  bot_minimax: 'Poziom 2 (Średni)',
  bot_aggressive_desc: 'Poziom 3',
  bot_cautious_desc: 'Poziom 1',
  bot_minimax_desc: 'Poziom 2',

  // Navigation & Lobby
  tab_solo: 'Tryb Solo (vs Boty)',
  tab_multiplayer: 'Multiplayer Online',
  tab_rules: 'Oficjalne Zasady',
  btn_create_room: 'Stwórz Pokój',
  btn_join_room: 'Dołącz do Pokoju',
  btn_start_game: 'Rozpocznij Grę',
  btn_add_bot: 'Dodaj Bota',
  btn_leave: 'Opuść Pokój',
  btn_copy_link: 'Kopiuj Link',
  link_copied: 'Link do pokoju skopiowany do schowka!',
  room_code: 'Kod Pokoju',
  enter_room_code: 'Wpisz kod pokoju (np. SLIME-8)',
  room_status_waiting: 'Oczekiwanie na graczy...',
  room_status_playing: 'Mecz w toku',
  room_private: 'Prywatny Pokój',
  room_public: 'Publiczny Pokój',
  toggle_public: 'Ustaw jako Publiczny',
  toggle_private: 'Ustaw jako Prywatny',
  public_rooms: 'Otwarte Pokoje Publiczne',
  no_public_rooms: 'Brak otwartych publicznych pokojów w tej chwili. Stwórz swój własny!',
  players_joined: 'Gracze przy stole',
  player_you: 'Ty',
  player_host: 'Gospodarz Pokoju',
  player_bot: 'Bot AI',
  team_a: 'Drużyna Niebieska (A)',
  team_b: 'Drużyna Czerwona (B)',

  // In-Game Actions
  action_bit_it: 'BIT-IT! (Podwój)',
  action_double_bit_it: 'DOUBLE BIT-IT! (Podwój Ponownie)',
  action_face: 'Podejmij Wyzwanie',
  action_fold: 'Pasuj (Chroń Punkty)',
  action_play_card: 'Zagraj Kartę',
  action_drag_or_tap: 'Przeciągnij kartę na środek lub dotknij, aby zagrać',
  your_turn: 'Twoja kolej na ruch!',
  waiting_for_player: 'Oczekiwanie na ruch gracza {name}...',
  waiting_for_challenge_response: 'Oczekiwanie na odpowiedź na wyzwanie...',
  btn_dismiss_hint: 'Zamknij podpowiedź',

  // Announcements & Game Events
  event_bit_it_called: '{name} ogłasza BIT-IT! Stawka rośnie do {stakes} punktów.',
  event_double_bit_it_called: '{name} odpowiada DOUBLE BIT-IT! Maksymalna stawka wynosi {stakes} punktów.',
  event_player_faced: '{name} podjął wyzwanie.',
  event_player_folded: '{name} spasował i ochronił swój wynik.',
  event_bluff_win: 'Wszyscy spasowali. {name} wygrywa rundę blefem!',
  event_corven_slay: 'Abate do Ezarion! {name} zagrał Corvena i zlikwidował Ezariona. Natychmiastowe Zwycięstwo w Rundzie!',
  event_trick_won: 'Lewa {trick}: {name} wygrywa kartą {card} (Moc {power}).',
  event_trick_tied: 'Lewa {trick} zakończyła się remisem.',
  event_triple_tie: 'Potrójny remis we wszystkich 3 lewach. Bazowa stawka następnej rundy jest podwojona!',
  event_round_won: 'Koniec rundy. Zwycięzca: {name} (+{points} pkt).',
  event_match_won: 'Wielkie Zwycięstwo! {name} osiąga cel {points} punktów!',
  round_num: 'Runda {num}',
  trick_num: 'Lewa {num}/3',
  stakes_current: 'Stawka: {stakes} pkt',
  stakes_normal: 'Normalna (2 pkt)',
  stakes_bit_it: 'BIT-IT! (4 pkt)',
  stakes_double_bit_it: 'DOUBLE BIT-IT! (8 pkt)',
  dealer_badge: 'Rozdający (Dealer)',

  // Scoreboard
  scoreboard_title: 'Tablica Wyników (Mecz kończy się przy 16 punktach)',
  binary_bits: 'Klejnoty Punktowe: [1] [2] [4] [8]',
  pts_counter: '{score} / 16 pkt',
  target_goal: 'Mecz kończy się przy 16 punktach',

  // Card Names
  card_ezarion: 'Ezarion (10)',
  card_phantom_general: 'Phantom General (9)',
  card_arrowin: 'Arrowin (8)',
  card_smerlin: 'Smerlin (7)',
  card_kx9: 'KX-9 (6)',
  card_koram: 'Koram (6)',
  card_wizzik: 'Wizzik (5)',
  card_brutus: 'Brutus (4)',
  card_snappy: 'Snappy (3)',
  card_zingo: 'Zingo (2)',
  card_floppy: 'Floppy (1)',
  card_corven: 'Corven (0)',
  card_corven_desc: 'Moc 0. Zdolność: Abate do Ezarion. Likwiduje Ezariona (10) i natychmiast wygrywa rundę, jeśli zostanie zagrany po nim w tej samej lewie!',

  // Rules Dialog
  rules_title: 'Oficjalne Zasady Slimelings: Bit-It!',
  rules_tab_basics: 'Przegląd',
  rules_tab_cards: 'Talia (30 Kart)',
  rules_tab_bit_it: 'Wyzwanie Bit-It!',
  rules_tab_tiebreaks: 'Remisy i Corven',
  rules_deck_overview: 'Talia zawiera 30 kart: 6 Złotych (moc 6 do 10), 20 Zwykłych (po 4 z wartości 1 do 5) i 4 Corvenów (0). Każdy gracz otrzymuje 3 karty na rundę.',
  rules_corven_slay_desc: 'Corven (0) ma zerową moc, lecz posiada unikalną zdolność Abate do Ezarion: zagrany PO Ezarionie (10) w tej samej lewie likwiduje go i natychmiast przynosi zwycięstwo w całej rundzie!',
  rules_tiebreak_desc: 'Wygranie 2 lew daje zwycięstwo w rundzie. Remisy w 2. lub 3. lewie rozstrzyga zwycięzca 1. lewy („Kto pierwszy, ten lepszy”). Potrójny remis podwaja stawkę kolejnej rundy.',
  rules_bit_it_ladder: 'Drabina stawek: Runda zaczyna się od stawki 1 przy spasowaniu / 2 przy wygranej. Jeśli gracz ogłasza Bit-It! i nikt nie przyjmuje wyzwania, zyskujesz 1 pkt. Jeśli wyzwanie zostanie podjęte, stawka rośnie do 2 przy spasowaniu / 4 przy wygranej. Jeśli ktoś ogłasza Double Bit-It! i rywal pasuje, zyskujesz 2 pkt; przy podjęciu wyzwania gra toczy się o 4 przy pasie / 8 przy wygranej. Mecz kończy się przy 16 punktach.',
  rules_binary_desc: '4 klejnoty o wartościach [1, 2, 4, 8] zliczają Twój wynik. Mecz kończy się przy 16 punktach!',
  btn_close: 'Zamknij',

  // Emotes & Chat
  emote_hello: 'Cześć wszystkim!',
  emote_good_luck: 'Powodzenia!',
  emote_bit_it: 'BIT-IT! Podejmiesz wyzwanie?',
  emote_no_way: 'Nie wierzę!',
  emote_well_played: 'Świetnie zagrane!',
  emote_oops: 'Ups, mój błąd!',
  emote_haha: 'Haha, mam cię!',
  emote_nice_try: 'Niezła próba!',

  // Settings & Status
  sound_on: 'Dźwięk: Włączony',
  sound_off: 'Dźwięk: Wyciszony',
  mode_offline: 'Lokalny Tryb Offline',
  error_room_not_found: 'Nie znaleziono pokoju. Sprawdź kod i spróbuj ponownie.',
  error_room_full: 'Ten pokój jest już pełny (osiągnięto limit graczy).',
  error_invalid_code: 'Nieprawidłowy kod pokoju. Wpisz od 4 do 12 znaków alfanumerycznych.',
  btn_play_again: 'Zagraj Ponownie',
  btn_back_to_lobby: 'Powrót do Lobby',
  status_connected: 'Połączony',
  slime_chat: 'Czat',
  event_player_emote: '{name}: "{emote}"',
  player_opponent: 'Przeciwnik',
  player_champion: 'Mistrz',
  card_point: '{val} pkt',
  btn_main_menu: 'Menu Główne',
  btn_next_round: 'Następna Runda',
  round_end_title: 'Koniec Rundy',
  round_winner_you: 'Wygrałeś rundę!',
  round_winner_other: '{name} wygrał rundę!',
  round_tied: 'Remis w rundzie!',
  round_points_awarded: '+{points} punktów',
  match_victory: 'Zwycięstwo!',
  match_defeat: 'Porażka',
  match_stats_rounds: 'Rozegrane rundy',
  match_stats_final_score: 'Wynik końcowy',
};
